export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SWITCH_ITEM = 'SWITCH_ITEM';



export const toggleSidebar = (data) => {
    return {
        type: TOGGLE_SIDEBAR,
        data: data
    }
}

export const switchMenuItem = (i,j) => {
    return {
        type: SWITCH_ITEM,
        data: {i:i,j:j}
    }
}